export const ENDPOINT_MACHINES = '/proxy.php?service=places';
export const ENDPOINT_MACHINES_UPDATED = '/proxy.php?service=updated';
export const ENDPOINT_DISTANCE_MATRIX = '/proxy-google.php?service=distance-matrix';
export const ENDPOINT_SEND_FEEDBACK = '/wp-json/bankomat/feedback';
